"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toShortGuid = toShortGuid;
function toShortGuid(guid) {
    return guid.replace(/-/g, '');
}
